module.exports = __webpack_public_path__ + "svg/icon-logo-wiggleline.svg";